export default {
  methods: {
    /**
     * JS equivalent of PHP's spaceship <=> operator
     * @param a
     * @param b
     * @returns {number}
     */
    spaceship(a, b) {
      return (a > b) - (a < b);
    },
  },
};
